import { render, staticRenderFns } from "./VentasComponent.vue?vue&type=template&id=1f1d4d90&scoped=true"
import script from "./VentasComponent.vue?vue&type=script&lang=js"
export * from "./VentasComponent.vue?vue&type=script&lang=js"
import style0 from "./VentasComponent.vue?vue&type=style&index=0&id=1f1d4d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d4d90",
  null
  
)

export default component.exports